import React, {
  createContext,
  useContext,
  useReducer,
  useState,
  useEffect,
} from "react";
import axios from "axios";
import {
  pengajuanReducer,
  lokasiReducer,
  mediaReducer,
  errorReducer,
} from "./Reducer";
import {
  all_media_api,
  date_api,
  dokumen_api,
  faq_api,
  kota_api,
  provinsi_api,
  setting_api,
} from "../services/services";

const Pengajuan = createContext();

export default function Context({ children }) {
  const [dokumenData, setdokumenData] = useState([]);
  const [dokumenStatus, setdokumenStatus] = useState(false);
  const [settingData, setsettingData] = useState([]);
  const [settingStatus, setsettingStatus] = useState(false);
  const [provinsiData, setprovinsiData] = useState([]);
  const [provinsiStatus, setprovinsiStatus] = useState(false);
  const [kabKotaData, setkabKotaData] = useState([]);
  const [kabKotaStatus, setkabKotaStatus] = useState(false);
  const [mediaRandomData, setMediaRandomData] = useState([]);
  const [mediaRandomStatus, setMediaRandomStatus] = useState(false);
  const [faqData, setfaqData] = useState([]);
  const [faqStatus, setfaqStatus] = useState(false);
  const [tanggalData, settanggalData] = useState({});
  const [tanggalStatus, settanggalStatus] = useState(false);

  useEffect(() => {
    // GET Date API
    axios
      .get(date_api)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (res.data.status === "success") {
            settanggalData(res.data.data);
            window.localStorage.setItem("status", res.data.data.status);
            settanggalStatus(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // GET DATA SETTING
    axios
      .get(setting_api)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (res.data.status === "success") {
            setsettingData(res.data.data);
            setsettingStatus(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // GET DATA DOKUMEN
    axios
      .get(dokumen_api)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (res.data.status === "success") {
            setdokumenData(res.data.data);
            setdokumenStatus(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // GET DATA MEDIA RANDOM
    axios
      .get(`${all_media_api}?random=true&length=12`)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (res.data.status === "success") {
            setMediaRandomData(res.data.data);
            setMediaRandomStatus(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // GET PROVINSI API
    axios
      .post(provinsi_api)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          const Provinsi = res.data.map((item) => {
            return {
              id: item.id,
              name: item.text,
            };
          });
          const newProvinsi = Provinsi.filter(function (items) {
            return items.id !== 0;
          });
          setprovinsiData(newProvinsi);
          setprovinsiStatus(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });

      // GET KAB KOTA API
    axios
    .post(kota_api, { id_provinsi: '9' })
    .then((res) => {
      if (res.status === 200 || res.status === 201) {
        const kota = res.data.map((item) => {
          return {
            id: item.id,
            name: item.text,
          };
        });
        const newKabKota = kota.filter(function (items) {
          return items.id !== 0;
        });
        setkabKotaData(newKabKota);
        setkabKotaStatus(true);
      }
    })
    .catch((error) => {
      console.log(error);
    });

    // GET FAQ
    axios
      .get(faq_api)
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (res.data.status === "success") {
            setfaqData(res.data.data);
            setfaqStatus(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return () => {
      setdokumenData([]);
      setdokumenStatus(false);
      setsettingData([]);
      setsettingStatus(false);
      setprovinsiData([]);
      setprovinsiStatus(false);
      setMediaRandomData([]);
      setMediaRandomStatus(false);
      settanggalData([]);
      settanggalStatus(false);
      setfaqData([]);
      setfaqStatus(false);
    };
  }, []);

  const pengajuanData = {
    nama_perusahaan: "",
    nama_media: "",
    alamat_kantor_media_perusahaan: {
      provinsi: "9",
      kota: "",
      kecamatan: "",
      kelurahan: "",
      jalan: "",
    },
    link_web: "http://www.",
    logo: "",
    nama_organisasi: "",
    email_perusahaan: "",
    status_media: "",
    nama_pimred: "",
    nohp_pimred: "",
    nama_wartawan: "",
    nohp_wartawan: "",
    npwp_perusahaan: "",
    no_akta: "",
    tahun_berdiri: "",
    nib: "",
    kbli: [],
    nama_bank: "",
    no_rekening: "",
    latitude: -2.120276,
    longitude: 106.113607,
    kategori: [],
    link_youtube: "",
    no_frekuensi: "",
    jumlah_oplah_dan_sebaran_media: "",
    jenis_tautan_sosial_media:"", //YOUTUBE | INSTAGRAM | TWITTER | FACEBOOK | TIKTOK
    link_tautan_sosial_media:"", //LINK URL
    dokumen: {
      foto_kantor: "",
      foto_plang_papan_nama: "",
      surat_permohonan_kerjasama: "",
      surat_tugas_wartawan: "",
      kartu_anggota_wartawan: "",
      ktp_pimpinan: "",
      ktp_wartawan: "",
      akta_pendirian_perusahaan: "",
      bukti_pengesahan_kemenkumham: "",
      nib: "",
      surat_keterangan_organisasi: "",
      npwp_perusahaan: "",
      // spt_tahun_terakhir: "",
      referensi_bank_dan_nomor_rekening: "",
      box_redaksi_media: "",
      izin_siaran: "",
      izin_penyelenggaraan_penyiaran: "",
      surat_keterangan_domisili: "",
      jumlah_pengunjung_web: "",
      daftar_harga:"",
    },
  };

  const dataKategori = [
    { id: "online", name: "Online" },
    { id: "cetak", name: "Cetak" },
    { id: "elektronik", name: "Elektronik" },
  ];

  const statusVerifikasi = [
    { id: 0, name: "Belum Terverifikasi" },
    { id: 1, name: "Proses Verifikasi" },
    { id: 2, name: "Sudah Terverifikasi" },
  ];

  const jenisSosialMedia = [
    { id: 'INSTAGRAM', name: "Instagram" },
    { id: 'TWITTER', name: "Twitter" },
    { id: 'FACEBOOK', name: "Facebook" },
    { id: 'YOUTUBE', name: "YouTube" },
    { id: 'TIKTOK', name: "TikTok" },
  ];

  const dataBank = [
    { id: "SUMSELBABEL", name: "SUMSEL BABEL" },
    { id: "SUMSELBABEL_SYARIAH", name: "SUMSEL BABEL SYARIAH" },
    { id: "BRI", name: "BRI" },
    { id: "BANK_DKI", name: "BANK DKI" },
    { id: "BNI", name: "BNI" },
    { id: "MANDIRI", name: "Mandiri" },
    { id: "BCA", name: "BCA" },
    { id: "MUAMALAT", name: "MUAMALAT" },
    { id: "PERMATA", name: "PERMATA" },
    { id: "BANK_BENGKULU", name: "BANK BENGKULU" },
    { id: "BANK_NOBU", name: "BANK NOBU" },
    { id: "BRK_SYARIAH", name: "BRK SYARIAH" },
  ];

  const [statePengajuan, dispatchPengajuan] = useReducer(pengajuanReducer, {
    pengajuanData: pengajuanData,
    statusPengajuan: false,
  });

  const [stateLokasi, dispatchLokasi] = useReducer(lokasiReducer, {
    kota: kabKotaData,
    kecamatan: [],
    kelurahan: [],
  });

  const [stateMedia, dispatchMedia] = useReducer(mediaReducer, {
    media: [],
    filter: [],
    skip: 0,
    length: 16,
    loading: true,
    keyword: "",
    total_data: 0,
  });

  const [stateError, dispatchError] = useReducer(errorReducer, {
    error: {},
  });

  return (
    <Pengajuan.Provider
      value={{
        statePengajuan,
        dispatchPengajuan,
        stateLokasi,
        dispatchLokasi,
        stateMedia,
        dispatchMedia,
        stateError,
        dispatchError,
        dataKategori,
        dataBank,
        statusVerifikasi,
        jenisSosialMedia,
        dokumenData,
        dokumenStatus,
        settingData,
        settingStatus,
        provinsiData,
        provinsiStatus,
        kabKotaData,
        kabKotaStatus,
        mediaRandomData,
        mediaRandomStatus,
        tanggalData,
        tanggalStatus,
        faqData,
        faqStatus,
      }}
    >
      {children}
    </Pengajuan.Provider>
  );
}

export const PengajuanState = () => {
  return useContext(Pengajuan);
};
